import { type FunctionComponent } from 'react';

import { Button, LoadingSpinner } from '@kanda-libs/ks-design-library';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useNovunaSignDocuments from './useNovunaSignDocuments';

const NovunaSignDocuments: FunctionComponent = () => {
  const { isLoading, link } = useNovunaSignDocuments();

  return (
    <>
      <PleaseWaitOverlay
        icon="check-circle-color"
        title="Your finance application has been accepted. You now need to sign your documents"
        labelLine1="You'll have received an email to the email address you applied with containing a link to sign your credit agreement documents. You can either follow that, or click the button below to be redirected."
        labelLine2="If you have already signed your documents, you don't need to do anything else. This page will refresh automatically and provide more information."
      />
      <LoadingSpinner stroke="purple-300" className="mx-auto mt-8" />
      {link && (
        <a href={link} className="mx-auto mt-8">
          <Button.Text
            id="novuna-sign-documents"
            label="Sign documents"
            className="w-64"
            disabled={isLoading}
            isLoading={isLoading}
          />
        </a>
      )}
    </>
  );
};

export default NovunaSignDocuments;
